import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/gift.svg';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/box-close.svg';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/heart.svg';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/info-question.svg';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/bx-chevron-right.svg';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/logout.svg';
import { mapGetters } from 'vuex';
import USE_MERCURE from '~/const/mercure';
import _logout from '~/helpers/logout-helper';
import IconTextLink from '~/components/molecules/Header/IconTextLink.vue';

var CloseButton = function CloseButton() {
  return import(
  /* webpackChunkName:"faq" */
  '~/components/atoms/CloseButton.vue');
};

export default {
  name: 'AccountLayer',
  components: {
    IconTextLink: IconTextLink,
    CloseButton: CloseButton
  },
  data: function data() {
    return {
      renderLink: true
    };
  },
  computed: _objectSpread({}, mapGetters({
    user: 'user/me',
    locale: 'i18n/locale'
  }), {
    accountDescription: function accountDescription() {
      return this.user ? this.$t('account-greeting', {
        name: this.user.firstName
      }) : this.$t('account-description');
    },
    accountIcon: function accountIcon() {
      return this.user ? 'account-connected' : 'account';
    },
    urlPrefix: function urlPrefix() {
      return "".concat(this.locale.market, "/").concat(this.locale.language);
    },
    accessUrl: function accessUrl() {
      var url = {
        dashboard: "/".concat(this.urlPrefix, "/account/dashboard"),
        orders: "/".concat(this.urlPrefix, "/account/orders"),
        profile: "/".concat(this.urlPrefix, "/account/personal-details/profile"),
        giftCards: "/".concat(this.urlPrefix, "/account/gift-voucher"),
        wishlist: "/".concat(this.urlPrefix, "/account/moodboard")
      };

      if (USE_MERCURE(this.locale.iso)) {
        url = {
          dashboard: this.user ? "/".concat(this.urlPrefix, "/user") : "/".concat(this.urlPrefix, "/login"),
          orders: "/".concat(this.urlPrefix, "/user/orders"),
          profile: "/".concat(this.urlPrefix, "/user/profile"),
          giftCards: "/".concat(this.urlPrefix, "/user/gift-cards"),
          wishlist: "/".concat(this.urlPrefix, "/user/wishlist"),
          help: "/".concat(this.urlPrefix, "/help")
        };
      }

      this.forceRerenderLink();
      return url;
    },
    quickAccessItems: function quickAccessItems() {
      return [{
        name: 'orders',
        link: this.accessUrl.orders,
        icon: 'box-close',
        tracking: {
          event_label: 'Mes commandes'
        }
      }, {
        name: 'personal-info',
        link: this.accessUrl.profile,
        icon: 'account',
        tracking: {
          event_label: 'Mes informations personnelles'
        }
      }, {
        name: 'vouchers',
        link: this.accessUrl.giftCards,
        icon: 'gift',
        tracking: {
          event_label: 'Mes cartes cadeaux, bons d’achat ou avoirs'
        }
      }, {
        name: 'wishlist',
        link: this.accessUrl.wishlist,
        icon: 'heart',
        tracking: {
          event_label: 'Ma wishlist'
        }
      }, {
        name: 'help',
        icon: 'info-question',
        link: USE_MERCURE(this.locale.iso) ? this.accessUrl.help : {
          FR: 'https://faq-france.maisonsdumonde.com',
          UK: 'https://help-uk.maisonsdumonde.com',
          PT: 'https://help-pt.maisonsdumonde.com',
          ES: 'https://faq-es.maisonsdumonde.com/es',
          IT: 'https://faq-italia.maisonsdumonde.com',
          CH: 'https://faq-suisse.maisonsdumonde.com',
          DE: 'https://faq-deutschland.maisonsdumonde.com',
          NL: 'https://faq-nederland.maisonsdumonde.com',
          AT: 'https://faq-oesterreich.maisonsdumonde.com'
        },
        tracking: {
          event_label: 'Aide et contact'
        }
      }];
    },
    logoutLink: function logoutLink() {
      if (USE_MERCURE(this.locale.iso)) {
        return this.$route.path;
      }

      return "/".concat(this.urlPrefix, "/deconnexion.html");
    },
    helpItemIndex: function helpItemIndex() {
      return this.quickAccessItems.length - 1;
    }
  }),
  methods: {
    tracking: function tracking(evt, data) {
      this.$root.$emit('generic-tracking', evt, {
        data: _objectSpread({
          event_category: 'Header',
          event_action: 'Mon compte',
          event_label: ''
        }, data)
      });
    },
    logout: function logout() {
      _logout();
    },
    forceRerenderLink: function forceRerenderLink() {
      var _this = this;

      this.renderLink = false;
      this.$nextTick(function () {
        _this.renderLink = true;
      });
    }
  }
};